import { TexturePreview } from '../../textures/TexturePreview';
import { isNumber } from 'lodash';
import { formatDateBasedOnPrecision } from '../../utils';
import { APIFieldType, TimelinesGridPrecisionUnit } from '@ardoq/api-types';
import { getMilestoneShape } from '../milestones/milestone';
import { IconSize } from '@ardoq/icons';
import styled from 'styled-components';
import { getCurrentLocale } from '@ardoq/locale';
import { isCurrentLocaleTimeFormat12Hour } from '@ardoq/date-time';
import { type I18nLocale, t } from '@ardoq/i18n';
import { MultipleFieldsPopoverProps } from '../../types';

const PopoverContentWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const getPhasePopoverText = (
  startDate: Date | null,
  endDate: Date | null,
  fieldType: APIFieldType,
  precision: TimelinesGridPrecisionUnit,
  i18nLocale: I18nLocale
) => {
  const excludeTime = fieldType === APIFieldType.DATE_ONLY_RANGE;

  const locale = getCurrentLocale();
  const isLocaleTimeFormat12Hour = isCurrentLocaleTimeFormat12Hour(locale);

  return `${
    startDate
      ? formatDateBasedOnPrecision({
          date: startDate,
          precision,
          excludeTime,
          isLocaleTimeFormat12Hour,
          currentLocale: locale,
        })
      : t(i18nLocale, 'timeline2024:phasePopover.noStartDate', 'No start date')
  } - ${
    endDate
      ? formatDateBasedOnPrecision({
          date: endDate,
          precision,
          excludeTime,
          isLocaleTimeFormat12Hour,
          currentLocale: locale,
        })
      : t(i18nLocale, 'timeline2024:phasePopover.noEndDate', 'No end date')
  }`;
};

const getMilestonePopoverText = (
  date: Date,
  precision: TimelinesGridPrecisionUnit
) => {
  const locale = getCurrentLocale();

  return `${formatDateBasedOnPrecision({
    date,
    precision,
    isLocaleTimeFormat12Hour: isCurrentLocaleTimeFormat12Hour(locale),
    currentLocale: locale,
  })}`;
};

export const HoveredFieldsPopover = ({
  popoverPhases,
  popoverMilestones,
  precision,
  i18nLocale,
}: MultipleFieldsPopoverProps) => (
  <>
    {popoverPhases.map(({ start, end, label, type, fieldIndex }) => (
      <PopoverContentWrapper key={fieldIndex}>
        {isNumber(fieldIndex) && (
          <TexturePreview textureIndex={fieldIndex} shape="RECTANGLE" />
        )}
        <div>
          {label && (
            <>
              {label}
              <br />
            </>
          )}
          {getPhasePopoverText(start, end, type, precision, i18nLocale)}
        </div>
      </PopoverContentWrapper>
    ))}
    {popoverMilestones.map(({ date, label, fieldIndex }) => (
      <PopoverContentWrapper key={fieldIndex}>
        {isNumber(fieldIndex) && getMilestoneShape(fieldIndex, IconSize.SMALL)}
        <div>
          {label && (
            <>
              {label}
              <br />
            </>
          )}
          {getMilestonePopoverText(date, precision)}
        </div>
      </PopoverContentWrapper>
    ))}
  </>
);
